import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import '../../stylesheets/Margins.css';
import '../../stylesheets/ForgetPassword.css';
import projectLogo from '../../project_logo.png'
import { AuthAPI } from "../../axios";

const ForgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
});

const ForgotPassword = () => {
  const navigate = useNavigate();

  const handleSubmit = (values) => {
    console.log('Form data', values);

    AuthAPI.forgotPassword(JSON.stringify(values))
    .then((res) => {
      if (res.code === 200) {
        console.log(res.code, "================================================");
        navigate('/verify-email');
      }
    })
    .catch((err) => {
      console.log(err);
    });
  };

  const getBack = () => {
    navigate('/login');
  };

  return (
    <div className="forget-container">
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <img
          src={projectLogo}
          alt="Profile"
          style={{
            width: '150px',
            height: '150px',
            borderRadius: '50%',
            objectFit: 'cover',
          }}
        />
      </div>
      <button className="back-button" onClick={getBack}>
        <ArrowBackIosIcon />
        Back to SignIn
      </button>
      <div className="marginTop-12">
        <span className="forget-text">Forgot your password?</span>
        <br />
        <span className="please-text">Please enter your email to reset the password</span>
      </div>
      <Formik
        initialValues={{ email: '' }}
        validationSchema={ForgotPasswordSchema}
        onSubmit={handleSubmit}
      >
        {() => (
          <Form className="forget-inputs">
            <span className="email-text">Email</span>
            <div className="forget-input">
              <Field name="email" type="email" placeholder="Enter your email" />
            </div>
            <ErrorMessage name="email" component="div" className="error" style={{ marginTop: '0px', marginLeft: '0px' }} />
            <div className="margin20">
              <button type="submit" className="forget-button">Reset Password</button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default ForgotPassword;
